import React from 'react'
import MainContainer from './common/MainContainer'
import checkoutsvg from "../assets/images/check.svg";
import numbertwo from "../assets/images/numebr2.svg";
import vector from "../assets/images/Vector.svg"
import three from "../assets/images/3.svg"


const Header = () => {
  return (
      <MainContainer>
          <header className="hidden md:flex items-center justify-between pt-10">
            <img
              src="https://cdn.blackincae.com/LyR-herbal-theraphy-logo-1-1-.svg"
              alt="Logo"
              className="w-[189px]"
            />

            <div className="flex items-center border border-[#EDEDED] rounded-full font-bold overflow-hidden">
              <div className="flex items-center justify-center text-[#233751] py-4 pl-3 pr-6 rounded-l-full">
                <img
                  src={checkoutsvg}
                  loading="lazy"
                  alt="check"
                  className="mr-2 w-6 h-6"
                />
                <a href="#">
                  <p className="text-[14px]">Checkout</p>
                </a>
              </div>
              <div className="flex items-center justify-center text-[#233751] py-4 pl-3 pr-6 rounded-l-full border-l border-[#EDEDED]">
                <img
                  src={checkoutsvg}
                  loading="lazy"
                  alt="check"
                  className="mr-2 w-6 h-6"
                />
                <a href="#">
                  <p className="text-[14px]">Upgrade Opportunities</p>
                </a>
              </div>
              <div className="px-[2px] pb-[2px] border-l rounded-full border-[#EDEDED]">
                <div className="flex items-center justify-center bg-[#2d4667] text-white py-3 pl-3 pr-6 rounded-full">
                  <img
                    src={numbertwo}
                    loading="lazy"
                    alt="check"
                    className="mr-2 w-8 h-8"
                  />
                  <a href="#">
                    <p className="text-[14px] pr-6">MY RECEIPT</p>
                  </a>
                </div>
              </div>
            </div>
          </header>
          <div className="block md:hidden  mx-auto max-w-3xl">
            <div className="pt-5 flex justify-center items-center">
              <img
                src="https://cdn.blackincae.com/LyR-herbal-theraphy-logo-1-1-.svg"
                alt="Logo"
                className="w-40"
              />
            </div>
            <div className="p-2">
              <div className="mx-4 p-4">
                <div className="flex items-center">
                  <div className="flex items-center text-[#233751] relative">
                    <div className="rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 border-[#233751] bg-[#233751]">
                      <img
                        src={vector}
                        alt=""
                        className="h-full w-full"
                      />
                    </div>
                    <div className="absolute top-0 -ml-10 text-center mt-16 w-32 text-sm font-bold uppercase text-[#233751]">
                      Checkout
                    </div>
                  </div>
                  <div className="flex-auto border-t-4 transition duration-500 ease-in-out border-[#233751]"></div>
                  <div className="flex items-center text-white relative">
                    <div className="rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 bg-[#233751] border-[#233751]">
                      <img
                        src={vector}
                        alt=""
                        className="h-full w-full"
                      />
                    </div>
                    <div className="absolute top-0 -ml-10 text-center mt-16 w-32 text-sm font-bold uppercase text-[#233751]">
                      Upgrade Opportunities
                    </div>
                  </div>
                  <div className="flex-auto border-t-4 transition duration-500 ease-in-out border-[#233751]"></div>
                  <div className="flex items-center text-gray-500 relative">
                    <div className="rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 border-[#233751]">
                      <img
                        src={three}
                        alt=""
                        className="h-full w-full"
                      />
                    </div>
                    <div className="absolute top-0 -ml-10 text-center mt-16 w-32 text-sm font-bold uppercase text-[#233751]">
                      My Receipt
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
     </MainContainer>
  )
}

export default Header